
import clientAxios from "../client";

import { formatQueryString } from "@/common/utils/common";

import type { QueryType } from "@/common/types/common";
import type {
    CollectionGalleryType,
    CollectionGalleryPayloadType,
} from "@/common/types/collection-gallery";

export async function collectionGalleryList(
    collection_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/${collection_id}/gallery/list${queryString}`
    );
}

export async function collectionGalleryGet(
    item_id: string
) {
    return await clientAxios.get(
        `collection/gallery/${item_id}/show`
    );
}

export async function collectionGalleryCreate(
    collection_id: string,
    payload: CollectionGalleryPayloadType
) {
    return await clientAxios.post(
        `collection/${collection_id}/gallery/create`,
        payload
    );
}

export async function collectionGalleryPatch(
    item_id: string,
    payload: Partial<CollectionGalleryType>
) {
    return await clientAxios.patch(
        `collection/gallery/${item_id}/patch`,
        { payload }
    );
}

export async function collectionGalleryDel(
    item_id: string,
) {
    return await clientAxios.del(
        `collection/gallery/${item_id}/delete`,
    );
}

export async function collectionGalleryFileList(
    item_id: string,
    query?: QueryType
) {
    const queryString = formatQueryString(query);

    return await clientAxios.get(
        `collection/gallery/${item_id}/file/list${queryString}`,
    );
}

export async function collectionGalleryFileCreate(
    collection_id: string,
    item_id: string,
    file: string,
) {
    return await clientAxios.post(
        `collection/${collection_id}/gallery/${item_id}/file/create`,
        { file }
    );
}

export async function collectionGalleryFileRemove(
    item_id: string,
    file_id: string,
) {
    return await clientAxios.del(
        `collection/gallery/${item_id}/file/${file_id}/delete`,
    );
}
